import {
    DomainInitPayload,
    SxmTypeDevice,
} from '@sxm-de/dev-kits/web-sdk/types';
import { logErrorFromMicroservicesSdk } from '@sxm-de/dev-kits/web-sdk/utils';

interface GetPotentialDevicesForSubscriptionFnPayload {
    subscriptionId: string;
}

export type GetPotentialDevicesForSubscriptionFn = (
    payload: GetPotentialDevicesForSubscriptionFnPayload,
) => Promise<{
    eligibleDeviceIds: string[];
    ineligibleDeviceIds: string[];
    devices: SxmTypeDevice[];
}>;

export function initGetPotentialDevicesForSubscriptionFn({
    dependencies,
}: DomainInitPayload): GetPotentialDevicesForSubscriptionFn {
    const { microservicesSdk } = dependencies;
    return async ({
        subscriptionId,
    }: GetPotentialDevicesForSubscriptionFnPayload) => {
        try {
            // /**
            //  * TODO: Microservices currently not returning radioId, only last four.
            //  */
            // const response =
            //     await microservicesSdk.domains.account.eligibleRadios({
            //         subscriptionId,
            //     });
            //
            // const eligibleDeviceIds = Array.from(
            //     new Set<string>(
            //         response.eligibleRadios?.map(
            //             (radio) => radio.last4DigitsOfRadioId,
            //         ),
            //     ),
            // );
            // const ineligibleDeviceIds = Array.from(
            //     new Set<string>(
            //         response.ineligibleRadios?.map(
            //             (radio) => radio.last4DigitsOfRadioId,
            //         ),
            //     ),
            // );
            //
            // const devices = new Set<SxmTypeDevice>();
            // const radios = [
            //     ...(response.eligibleRadios ?? []),
            //     ...(response.ineligibleRadios ?? []),
            // ];
            //
            // for (const radio of radios) {
            //     devices.add(mapSmsDeviceToDevice(radio));
            // }
            //
            // return {
            //     eligibleDeviceIds,
            //     ineligibleDeviceIds,
            //     devices: Array.from(devices.values()),
            // };

            /**
             * TODO: Temporarily return mocked data until microservice endpoint is online.
             */
            return {
                eligibleDeviceIds: ['990005530920'],
                ineligibleDeviceIds: ['990005530921'],
                devices: [
                    {
                        id: '990005530920',
                        isVirtualId: false,
                        nickname: '',
                        radioIdLastFour: '0920',
                        vehicle: {
                            make: 'Ford',
                            model: 'F-150',
                            year: '2024',
                            vin: '1FTFW1CT8EFB42220',
                            yearMakeModel: '2024 Ford F-150',
                        },
                        type: 'car',
                    },
                    {
                        id: '990005530921',
                        isVirtualId: false,
                        nickname: '',
                        radioIdLastFour: '0921',
                        vehicle: {
                            make: 'Ford',
                            model: 'Mustang',
                            year: '1965',
                            vin: '5F07K423456',
                            yearMakeModel: '1965 Ford Mustang',
                        },
                        type: 'car',
                    },
                ],
            };
        } catch (error: any) {
            logErrorFromMicroservicesSdk(error, dependencies);
            throw new Error('SYSTEM');
        }
    };
}
